module.exports = __webpack_public_path__ + "img/zoetrope2.1523dace.jpg";